import * as types from "../../constants/actionTypes";
import initialState from "./initialState";

export function taskLogs(state = initialState.taskLogs, action) {
  switch (action.type) {
    case types.FETCH_TASK_LOGS_SUCCESS:
      return { ...state, show: true, logs: action.taskLogs.Logs };

    case types.CLOSE_TASK_LOGS:
      return initialState.taskLogs;

    default:
      return state;
  }
}

export function propertyBag(state = initialState.propertyBag, action) {
  switch (action.type) {
    case types.FETCH_PROPERTY_BAG_SUCCESS:
      return { ...state, show: true, bag: action.propertyBag };

    case types.UPDATE_PROPERTY_FOR_PROPERTY_BAG: {
      let changed = false;
      let updatedBag = JSON.parse(JSON.stringify(state.bag));

      for (let i = 0; i < updatedBag.Keys.length; i++) {
        let item = updatedBag.Keys[i];
        for (let j = 0; j < item.Values.length; j++) {
          let value = item.Values[j];
          if (value.Id === action.id && value.Value !== action.value) {
            value.Value = action.value;
            changed = true;
            break;
          }
        }

        if (changed) {
          break;
        }
      }

      if (changed) {
        return { ...state, bag: updatedBag, updated: true };
      }

      return state;
    }
    case types.UPLOAD_PROPERTY_BAG_SUCCESS:
    case types.CLOSE_PROPERTY_BAG:
      return initialState.propertyBag;

    default:
      return state;
  }
}
